export const CANCELLATION_STEPS = {
    SURVEY: 'survey',
    OFFER: 'offer',
    OFFER_ACCEPTED: 'offer-accepted',
    GOODBYE: 'goodbye',
} as const;

export type CancellationStep = (typeof CANCELLATION_STEPS)[keyof typeof CANCELLATION_STEPS];

export const OFFER_TYPES = {
    FREE_MONTH: 'free-month',
    TWO_MONTHS_DISCOUNT: 'two-months-discount',
} as const;

export type OfferType = (typeof OFFER_TYPES)[keyof typeof OFFER_TYPES];

export const FLOW_ANALYTICS_EVENTS = {
    OFFER_VIEWED: 'cancellation-present-offer-viewed',
    OFFER_ACCEPTED: 'cancellation-present-offer-accepted',
    OFFER_IGNORED: 'cancellation-present-offer-ignored',
    FLOW_SURVEY: 'cancellation-flow-survey',
    FLOW_SURVEY_RATING: 'cancellation-flow-survey-rating',
    FLOW_SURVEY_FEEDBACK: 'cancellation-flow-survey-feedback',
    CONFIRMATION_VIEWED: 'cancellation-subscription-cancelled-confirmation',
    FREE_MONTH_CONFIRMATION: 'free-one-month-offer-confirmation-viewed',
    TWO_MONTHS_CONFIRMATION: 'two-months-discount-offer-confirmation-viewed',
} as const;
